module.exports = __webpack_public_path__ + "GuidebookClosed-f83eec3b37ebaac8aed397ec6fa883e6.png";